import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import './AmexExperientialEmailOptIn.scss';

const AmexExperientialEmailOptIn = (
  {
    emailOptInConfig: {
      title,
      text,
      cta: {
        label,
        url,
        utm,
      },
    },
    Analytics,
  }
) => {
  const sanitizedTitle = sanitizeString(title);
  const sanitizedText = sanitizeString(text);

  return (
    <div className="AmexExperientialEmailOptIn">
      <div className="container">
        <div className="AmexExperientialEmailOptIn__wrapper">
          <h2
            className="AmexExperientialEmailOptIn__title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedTitle,
            }}
          />
          <p
            className="AmexExperientialEmailOptIn__text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedText,
            }}
          />
          <p className="AmexExperientialEmailOptIn__text-cta">
            <Link
              rel="noopener noreferrer"
              target="_blank"
              href={`${url}${utm}`}
              className="AmexExperientialEmailOptIn__cta"
              onClick={() => {
                const extraParam = {
                  action_name: 'Email Opt In - Click',
                };
                handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
              }}
            >
              {label}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

AmexExperientialEmailOptIn.propTypes = {
  emailOptInConfig: PropTypes.shape({
    hide_section: PropTypes.bool,
    title: PropTypes.string,
    text: PropTypes.string,
    cta: PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      utm: PropTypes.string,
    }),
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexExperientialEmailOptIn;
